import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import islands from '@constants/islands'
import { OPENMAPFIELDS } from '@modules/open-street-map-field'
import toastr from '@modules/toastr'
import Swal from 'sweetalert2'
import { fullName } from '@modules/form-wizard/utils'
import moment from 'moment'


export default class ComplaintForm extends React.Component {
  resource = '/moen/health/general_complaint_forms'
  form_key = 'general_complaint_form'
  defaults = {}

  // Delete lines as needed
  fee = 99
  free = true
  postpaid = true
  skip_location = true
  hide_buttons = false
  custom_actions = [
    // Send Customer update email on inspector assignment
    {
      text: 'Assign Officer',
      icon: 'bullhorn',
      roles: [['officer', 'senior_officer']],
      test: r => ['pending', 'processing'].includes(r.application_decision),
      fn: async record => {
        // Get the list of officers
        const officerList = {};
        const { data } = await $app.axios.get(`${this.resource}/show_field_officers`)
        const officerMap = data.records.map(x => {
          return { id: x.id, name: `${x.first_name} ${x.last_name}` }
        })
        this.setState({ all_reviewers: officerMap })
        this.state.all_reviewers.forEach(e => {
          officerList[`${e.id}`] = e.name;
        })

        let officerID = null
        const {isDismissed, value} = await Swal.fire({
          icon: 'question',
          title: 'Assign Officer for inspection',
          html: `
            Select which field officer you would wish to assign to this application.
          `,
          input: 'select',
          inputOptions: officerList,
          showCancelButton: true,
          confirmButtonText: 'Send',
        })
  
        if (isDismissed) return
        officerID = value
        // console.log(officerID)

        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: 'assign reviewer',
              reviewer_id: officerID,
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            console.log(view)
            view.application_decision = 'assigned reviewer'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application approved for review successfully')
        } catch (err) {
          console.error(err)
          Swal.fire(
            'Oops...',
            'An error occurred while approving the application for review',
            'error'
          )
        }
      }
    },
    {
      text: 'Confirm Inspection Date',
      icon: 'check-square',
      roles: [['field_officer', 'inspector']],
      test: r => ['pending', 'processing'].includes(r.application_decision),
      fn: async record => {
        let inspectionDate

        // Set value of Inspection Date
        const datePrompt = await Swal.fire({
          icon: 'question',
          title: 'Inspection Date?',
          html: `
            <p>
              What is your recommended inspection date regarding the applicant,
              <strong>${fullName(record.user, 'initial')}</strong>,
              <br/>
              <span><b>Complaint Type:</b> <u>${record.complaint_type}</u></span>,
              <br/>
              <span><b>Location:</b> <u>${record.complaint_location.substring(0, 120)}</u></span>
            </p>

            <div>
              <input type="date" id="inspection-date" class="swal2-input" min="${moment().format('YYYY-MM-DD')}">
            </div>
          `,

          showCancelButton: true,
          confirmButtonText: 'Submit',
          preConfirm: () => {
            const date = (document.getElementById('inspection-date')).value;
            if (!date) {
              Swal.showValidationMessage('Please select a date');
            }
            console.log(date)
            return date;
          },
        })
  
        if (datePrompt.isDismissed) return

        inspectionDate = datePrompt.value
    
        if (inspectionDate) {
          const { isConfirmed } = await Swal.fire({
            icon: 'question',
            title: 'Confirm Details',
            html: `
              <p>
                What is your recommended inspection date regarding the applicant,
                <strong>${fullName(record.user, 'initial')}</strong>,
                <br/>
                <span><b>Complaint Type:</b> <u>${record.complaint_type}</u></span>,
                <br/>
                <span><b>Location:</b> <u>${record.complaint_location.substring(0, 120)}</u></span>
              </p>
              Inspection date to be: <b>${inspectionDate}</b>
              <br/>
            `,
            showCancelButton: true,
            confirmButtonText: 'Submit',
          })
    
          if (isConfirmed) {
            await this.submitToNewLevel('approved', record, inspectionDate)
          }
        }
      }
    },
    {
      text: 'Approve',
      icon: 'check',
      roles: [['field_officer', 'inspector']],
      test: r => ['pending', 'processing'].includes(r.application_decision),
      fn: record =>
        Swal.fire({
          icon: 'success',
          title: 'Confirm Approval',
          text: 'Are you sure you want to approve this application?',
          confirmButtonText: 'Approve',
          showCancelButton: true,
        }).then(async result => {
          if (result.isConfirmed) {
            // await this.approve(record)
          }
        }),
    },
    {
      text: 'Deny',
      icon: 'ban',
      roles: [['field_officer', 'inspector', 'officer', 'senior_officer']],
      test: r => ['pending', 'processing'].includes(r.application_decision),
      fn: record =>
        Swal.fire({
          icon: 'error',
          title: 'Confirm Denial',
          text: 'Are you sure you want to deny this application?',
          confirmButtonText: 'Deny',
          showCancelButton: true,
        }).then(async result => {
          if (result.isConfirmed) {
            // await this.deny(record)
          }
        }),
    },
  ]

  submitToNewLevel = async (value, record, inspectionDate = null) => {
    this.setState({ loading: true })
    const { resource, form_key } = this
    const { axios } = $app

    try {
      await axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: value,
          inspection_date: inspectionDate,
        },
      })

      toastr.success('Success', 'The application was successfully updated')
    } catch (error) {
      console.error(error)
      toastr.error('Error', error.response?.data?.error || 'Something went wrong with trying to update this application')
    } finally {
      this.setState({ loading: false })
    }
  }

  columns = props => [
    {
      name: 'Inspection Date',
      selector: row => row.inspection_date ? moment(row.inspection_date).format('MMMM Do YYYY, h:mm a') : 'N/A',
      sortable: true,
      searchable: r => r.inspection_date,
    },
  ]

  validate = async form => {
    const update = {}
    const complaintsArray = Array.from(form.complaint_type || []) // Convert Checklist of type Set to Array
    update.complaint_type = complaintsArray

    // Validation: Ensure at least one complaint type is selected
    if (complaintsArray.length === 0) {
      return 'No complaint types were selected'
    }
    
    if(this.coordinates) {
      update.latitude = this.coordinates[0]
      update.longitude = this.coordinates[1]
    }

    return update
  }

  foremost = null

  fields = (form, formRef) => [
    {
      name: 'inspection_date',
      type: 'date',
      showYearDropdown: true,
      hide: true,
      view: {
        label: 'Inspection Date',
        value: v => (v ? moment(v).format('MMMM Do YYYY, h:mm a') : 'N/A')
      },
    },

    "::Contact Information",
    {
        name: "island",
        options: islands,
        required: false,
    },
    {
        name: "street",
        label: "Street Address",
        hint: "eg. Centerville, Collins Avenue, #5",
        required: false,
    },
    {
        name: "subdivision",
        label: "Subdivision",
        required: false,
    },
    {
        name: "po_box",
        label: "P.O. Box",
        required: false,
    },
    {
        name: "home_phone",
        label: "Home Phone #",
        type: "phone",
        required: false,
    },
    {
        name: "work_phone",
        label: "Work Phone #",
        type: "phone",
        required: false
    },
    {
        name: 'confidentiality',
        label: 'Do you wish to remain confidential?',
        type: 'select:bool',
        hint: 'If yes, your contact information will not be shared with the public. However, it may still be accessible to government employees and officials.',
    },
    // {
    //     name: "email",
    //     type: "email",
    //     required: false
    // },

    "::Complaint Details",
    {
        name: "complaint_type",
        label: "Describe Nature of Complaint",
        type: "checklist",
        required: true,
        options: [
            { label: "Septic Tank - Overflowing", value: "septic tank - overflow" },
            { label: "Septic Tank - Defective", value: "septic tank - defective" },
            { label: "Inadequate Garbage Storage", value: "inadequate garbage storage"},
            { label: "Garbage Accumulation & Litter", value: "garbage accumulation & litter"},            
            { label: "Roadside Garage", value: "roadside garage" },
            { label: "Overgrown Lot", value: "overgrown lot" },
            { label: "Food Establishment", value: "food establishment" },
            { label: "Rotten Food", value: "rotten food" },
            { label: "Expired Food", value: "expired food"},
            { label: "Offensive Odor", value: "offensive odor"},
            { label: "Other Nuisances", value: "other"},
        ],
        multi: true
    },

    {
        name: "complaint_desc",
        label: "Give details",
        type: "textarea",
    },

    "::Location of Complaint/Request",
    ...OPENMAPFIELDS(this, form, formRef, null),
    {
        name: "complaint_location",
        label: "Location of Complaint/Request",
        type: "textarea",
        hint: "Detailed directions and street address where complaint is located"
    },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
